<template>
    <div class="task-device-show" >
        <div class="body">
            <div class="left">
                <div class="flex-center-y center">
                    <img :src="downloadImg + taskDevice.productImage1"/>
                    <div class="name">
                        <div class="title-small">{{taskDevice.productName}}</div>
                        <div>{{taskDevice.productModel}}</div>
                    </div>
                </div>
            </div>
            <div  class="right">{{taskDevice.count}}</div>
        </div>
    </div>
</template>

<script>
    import {downloadImg} from "@/config"
    import { Dialog, Icon, Stepper} from "vant"


    export default {
        components: { Stepper, Icon, Dialog},
        props: {
            taskDevice: {type: Object, required: true}
        },
        data() {
            return {
                taskId: this.$route.params.id,
                downloadImg,
            };
        },
        computed: {},
        created() {
        },
        mounted() {

        },
        methods: {
            plusCount() {
                this.$http.tokiot.prospect.taskDevice.submit({
                    taskId: this.taskId,
                    productId: this.taskDevice.productId,
                    count: this.taskDevice.count + 1
                })
                    .then(res => {
                        if (res) {
                            this.$emit("onRefresh")
                        }
                    })
            },
            minusCount() {
                this.$http.tokiot.prospect.taskDevice.submit({
                    taskId: this.taskId,
                    productId: this.taskDevice.productId,
                    count: this.taskDevice.count - 1
                })
                    .then(res => {
                        if (res) {
                            this.$emit("onRefresh")
                        }
                    })
            },
            deleteDevice() {
                Dialog.confirm({
                    message: "确定删除吗",
                }).then(() => {
                    this.$toast.loading("正在处理中");
                    this.$http.tokiot.prospect.taskDevice.delete({id: this.taskDevice.id})
                        .then(res => {
                            this.$toast.clear();
                            if (res) {
                                this.$toast.success("删除成功");
                                this.$emit("onRefresh")
                            }
                        })
                })
            }
        },
        watch: {}
    };
</script>

<style lang="less" scoped>
    .task-device-show {
        margin: 0 5px 5px;
        border: 1px solid #aaa;
        border-radius: 8px;
        & > .body {
            display: flex;
            & > .left {
                width: 100%;
                & > .center {
                    padding: 5px;
                    display: flex;
                    & > img {
                        width: 55px;
                        height: 55px;
                        background: #aaa;
                       // border-radius: 8px;
                    }
                    & > .name {
                        margin-left: 15px;
                        height: 100%;
                        display: flex;
                        flex-direction: column;

                        & > div {
                            line-height: 1.5;
                        }
                    }
                }
            }
            & >.right{
                width: 60px;
                display: flex;
                align-items: center;
            }
        }
    }
</style>

